import { Anchor, Flex, FlexProps, Text } from "@govlaunch/web";
import React from "react";
import { FormattedMessage } from "react-intl";

export default function ProjectIsPendingVerification(props: FlexProps) {
  return (
    <Flex
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      backgroundColor="orange.500"
      position="absolute"
      width="100%"
      top={0}
      py={2}
      px={8}
      borderRadius="md"
      {...props}
    >
      <Text as="span" fontSize="sm" textTransform="uppercase">
        <FormattedMessage
          defaultMessage="This project will be published once it is verified. <link>Learn More.</link>" id="d725dH"
          values={{
            link: (text: string) => {
              return (
                <Anchor
                  external="outside-redirect"
                  href="https://help.govlaunch.com/en/articles/3740777-how-do-i-verify-my-projects"
                >
                  {text}
                </Anchor>
              );
            },
          }}
        />
      </Text>
    </Flex>
  );
}
